import NNavbar from './navbar';
import Footer from './footer';
import Callback from './callback';
import '../styles/aboutus.css';
import { Container, Row, Col, Card } from "react-bootstrap";
import aboutImage from '../media/about/landing_image.jpg';
import teamImage from '../media/about/landing_image2.jpg';

function Aboutus(){
    return(
        <>
            <NNavbar/>
                 <section className="aboutus-section">
      {/* Full-width Row for image + text */}
      <Row className="g-0 aboutus-full-row">
        <Col md={6} className="position-relative img-col">
          <div
            className="aboutus-image"
            style={{ backgroundImage: `url(${aboutImage})` }}
          ></div>
        </Col>
        <Col md={6} className="d-flex align-items-center">
          <div className="aboutus-content p-4 text-center">
            <br/><br/><br/><br/>
            <h2 className="mb-3">
              About <span className="highlight">US</span>
            </h2>
            <p>
              Q Plus Management Consultancy (FZC) is a UAE-based firm offering expert services in bookkeeping, auditing, taxation, payroll, budgeting and financial consulting. With a tech-driven, global team, we provide accurate and proactive support across industries.
            </p>
           
          </div>
        </Col>
      </Row>

      {/* Vision & Mission inside a Container */}
      <Container className="py-5 vm-container">
        <Row className="g-4 text-center">
          <Col md={6}>
            <Card className="info-card h-100">
              <Card.Body>
                <h5 className="fw-bold">Vision</h5>
                <p className="mb-0">
                  We don’t just serve clients, we partner in your progress. As your business grows, our reputation grows with you. 
                  We're not just here for the big players, we support the scrappy startups and scaling midsize firms too.
                </p>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6}>
            <Card className="info-card h-100">
              <Card.Body>
                <h5 className="fw-bold">Mission</h5>
                <p className="mb-0">
                  Our mission is to set the global benchmark in financial consultancy by delivering clear, dependable and timely solutions, each tailored to the specific challenges and opportunities of every industry we serve.
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      <br/><br/><br/><br/>
    </section>
       <section className="qplus-section py-5">
      <Container fluid>
        <Row className="g-0">
          {/* Left Image */}
          <Col md={6}>
            <div
              className="qplus-image"
              style={{ backgroundImage: `url(${teamImage})` }}
            ></div>
          </Col>

          {/* Right Content */}
          <Col md={6} className="qplus-content text-white d-flex align-items-center">
            <div className="p-4 p-md-5">
            <center>
              <h2 className="fw-bold mb-3">The Q+ Difference</h2>
              <p className="lead mb-4 qdiff-content">
                At Q Plus, we go beyond routine accounting. We’re structured to support business owners, founders and finance heads who value insight, accuracy and long-term reliability.
              </p>

            </center>
              
              <div className="qplus-point mb-4">
                <h6 className="fw-bold">Strategic Over Transactional</h6>
                <p>We're not just ticking boxes, we’re thinking ahead. From reporting to compliance, our focus is to give you clarity, not just closure. That means timely advice, proactive alerts and dependable numbers that help guide decisions.</p>
              </div>

              <div className="qplus-point mb-4">
                <h6 className="fw-bold">Built to Scale With You</h6>
                <p>Whether you're a startup, setting up your first books or a growing enterprise navigating new tax regimes, our model adapts. As your business expands, our services evolve to meet the complexity—seamlessly and without disruption.</p>
              </div>

              <div className="qplus-point mb-4">
                <h6 className="fw-bold">Industry Aware, Insight Driven</h6>
                <p>We work across tech, manufacturing, retail and services—which means we bring lessons from across the board to every client. This multi-sector experience allows us to give advice that’s not just correct, but relevant.</p>
              </div>

              <div className="qplus-point mb-4">
                <h6 className="fw-bold">Global Systems, Local Precision</h6>
                <p>From multi-currency transactions to GAAP/IFRS reporting, we bring international accuracy-But we also understand the regional nuances—from UAE VAT to ESR compliance—ensuring your operations stay aligned, both globally and locally.</p>
              </div>

              <div className="qplus-point">
                <h6 className="fw-bold">One Point of Contact, Full-Spectrum Support</h6>
                <p>No need to juggle vendors. From payroll to internal audits, dashboards to tax filings, we offer it all under one roof—with one accountable team and no loss in context.</p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
            <Callback/>
            <Footer/>
        </>
    )
}

export default Aboutus;